import React from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from "./components/Header";
import Hero from "./components/Hero";
import AboutUs from "./components/AboutUs";
import Career from "./components/career";
// import OurMission from "./components/OurMission";
import Services from "./components/Services";
import ScrollToTop from './components/ScrollToTop';
import Footer from "./components/Footer";
// import ValuesCarousel from './components/ValuesCarousel';
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Capabilities from "./pages/Capabilities";
import Contact from "./pages/Contact";
import ServicesDetail from "./pages/ServicesDetail";
import Leadership from "./pages/Leadership";
import CertificationsBar from "./components/CertificationsBar";
import LeadershipPreview from "./components/LeadershipPreview";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <Routes>
        {/* Route pour la page d'accueil */}
        <Route path="/" element={
          <>
            <Hero />
            <CertificationsBar />
            <AboutUs />
            <LeadershipPreview />
            <Services />
            {/* <ValuesCarousel /> */}
          </>
        } />
        
        {/* Route pour la page Privacy Policy */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/capabilities" element={<Capabilities />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/aboutus" element={<AboutUs />} />
        {/* <Route path="/mission" element={<OurMission />} /> */}
        <Route path="/services" element={<Services />} />
        <Route path="/services/:serviceId" element={<ServicesDetail />} />
        <Route path="/leadership" element={<Leadership />} />
        <Route path="/career" element={<Career />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;